module.exports = __webpack_public_path__ + "img/file-upload.29cdddcd.svg";